import { EventDispatcher } from '../../events/EventDispatcher/EventDispatcher';
import { Disposable } from '../DisposableContainer/DisposableContainer';
import { TimingUtils } from '../TimingUtils/TimingUtils';

/**
 * @performance only calculate ticks when there is at least one event listener
 */
export class ClockTick {
  private constructor() {}
  private static readonly dispatcher = new EventDispatcher<{
    onSecondTick: number;
    onDayTick: null;
  }>();
  private static lastSeconds: number = 0;
  private static lastDay: number = 0;
  private static initialized: boolean = false;
  private static updateDisposable: Disposable | null = null;
  public static onDayTick(callback: () => void): Disposable {
    this.initializeIfNeeded();
    return this.dispatcher.addEventListener('onDayTick', callback);
  }
  public static onSecondTick(callback: (second: number) => void): Disposable {
    this.initializeIfNeeded();
    return this.dispatcher.addEventListener('onSecondTick', callback);
  }
  public static deinitialize(): void {
    this.initialized = false;
    this.updateDisposable?.dispose();
  }
  private static initializeIfNeeded(): void {
    if (!this.initialized) {
      const date = new Date();
      this.lastSeconds = date.getSeconds();
      this.lastDay = date.getDate();
      this.scheduleNextUpdate();
      this.initialized = true;
    }
  }
  private static scheduleNextUpdate(): void {
    const date = new Date();
    const msUntilNextSecond = 1000 - date.getMilliseconds();
    this.updateDisposable = TimingUtils.setTimeout(() => {
      this.update();
      this.scheduleNextUpdate();
    }, msUntilNextSecond);
  }
  private static update(): void {
    const date = new Date();
    const seconds = date.getSeconds();
    const day = date.getDate();
    if (seconds !== this.lastSeconds) {
      this.dispatcher.dispatchEvent('onSecondTick', seconds);
      this.lastSeconds = seconds;
    }
    if (day !== this.lastDay) {
      this.dispatcher.dispatchEvent('onDayTick', null);
      this.lastDay = day;
    }
  }
}